import { useQuery } from '@tanstack/react-query'

import type { GetEstimateInfoMinimalByIdResponse } from '../../types/estimate.js'

import { apiClient } from '../../lib/client.js'
import { publicEstimateKeys } from './keys.js'
import { quoteAuthHeaders } from './quote-token.js'

export const useGetPublicQuoteInfoMinimalQuery = (responseId: string, enabled = true) =>
  useQuery({
    enabled,
    queryFn: async () => {
      const response = await apiClient.client.get<GetEstimateInfoMinimalByIdResponse>(
        `/public/estimate-responses/${responseId}/info-minimal`,
        { headers: quoteAuthHeaders(responseId) }
      )
      return response.data
    },
    queryKey: publicEstimateKeys.quoteInfoMinimal(responseId),
    retry: false,
  })
